const Employreducer = (state, { type, payload }) => {
    switch (type) {
        case 'setemploy':
            return { ...state, employ: payload.employ, active_employ: payload.active_employ, certificate: payload.certificate, department: payload.department };
        case 'setsearch':
            return { ...state, employ: payload };
        case 'setactivesearch':
            return { ...state, active_employ: payload };
        case 'setsalarylist':
            return { ...state, salary_list: payload };
        case 'setsalarylistdetail':
            return { ...state, salary_detail: payload };
        case 'setchekout':
            return { ...state, employ_chekout: payload };
        default:
            return state;
    }
}

export default Employreducer;